<template>
  <div class="main">
    <my_menu active_name="1-0" :open_active="['1']"></my_menu>

    <div class="content">
      <div class="table_box">
        <Spin fix size="large" v-if="loading"></Spin>
        <div class="left_list">
          <div v-for="(item, i) in template_data" :key="i"
            :class="template_select == i ? 'left_list_card' : 'left_list_card2'" @click="click_template(item, i)">
            <div class="template_title">
              <div class="template_number">
                {{ i + 1 }}
              </div>
              {{ item.title }}
            </div>
            <div @click="update_template(item)">
              <Icon type="ios-create-outline" size="20" />
            </div>
            <!-- <div>
              {{ item.template_id }}
            </div>
            <div class="create_time">
              {{ item.create_time }}
            </div> -->
          </div>
          <div class="left_list_card3">
            <div @click="click_add_template">
              <Icon type="md-add" />添加消息模板
            </div>
          </div>
        </div>
        <div class="right_box">
          <div class="template_card">
            <div class="template_right">
              <div class="template_id">
                当前模板编号：{{ current_template.template_id }} <div @click="copy_id(current_template)">
                  <Icon size="20" type="md-copy" />
                </div>
              </div>
              <Button type="primary" @click="click_add_field()">添加字段</Button>
            </div>

            <div v-for="(item, i) in current_field_data" :key="i" class="template_div">
              <div>
                {{ item.name }}
              </div>
              <div class="field_type">
                {{ item.field_type }}
              </div>
              <div class="field_type">
                {{ item.field_id }}
              </div>
            </div>
          </div>
          <div class="setting_div2">
            <Spin fix v-if="right_loading">加载中...</Spin>

            <div class="setting_font">
              消息接收配置信息
              <div>
                已使用：{{ use_count }}次
              </div>
            </div>
            <div class="sender_box">
              <div>
                <img class="avatar_img" v-if="receiver_info.sender_avatar != ''" :src="receiver_info.sender_avatar"
                  alt="">
                <Icon type="ios-close-circle" v-else size="35" color="red" />
              </div>

              <div class="sender_name">
                <div style="margin-right:10px">
                  {{ receiver_info.sender_name }}
                </div>
                <Input v-model="receiver_info.sender_id" placeholder="输入发送人id" style="width: 100px"
                  @on-blur="switch_change('sender_id', receiver_info.sender_id)" size="small" />
              </div>
            </div>
            <div class="setting_div">
              <div>
                是否停用：
              </div>
              <div>
                <Switch true-color="#ff4949" size="small" v-model="receiver_info.is_stop_value"
                  @on-change="switch_change('is_stop', $event)" />
              </div>
            </div>
            <div class="setting_div">
              <div>
                使用后回复发送者：
              </div>
              <div>
                <Switch size="small" v-model="receiver_info.sender_status_value"
                  @on-change="switch_change('sender_status', $event)" />
              </div>
            </div>

            <div class="setting_div">
              <div>
                项目客服接收：
              </div>
              <div>
                <Switch size="small" v-model="receiver_info.project_kefu_status_value"
                  @on-change="switch_change('project_kefu_status', $event)" />
              </div>
            </div>
            <div class="setting_div">
              <div>
                项目组长接收：
              </div>
              <div>
                <Switch size="small" v-model="receiver_info.zhuguan_status_value"
                  @on-change="switch_change('zhuguan_status', $event)" />
              </div>
            </div>
            <div class="setting_div">
              <div>
                项目运营总接收：
              </div>
              <div>
                <Switch size="small" v-model="receiver_info.team_leader_status_value"
                  @on-change="switch_change('team_leader_status', $event)" />
              </div>
            </div>
            <div class="setting_div">
              <div>
                是否有跳转按钮：
              </div>
              <div>
                <Switch size="small" v-model="receiver_info.is_jump_value"
                  @on-change="switch_change('is_jump', $event)" />
              </div>
            </div>
            <div class="setting_div3">
              <div>
                功能按钮名称
              </div>
              <Input v-model="receiver_info.jump_title" maxlength="250" show-word-limit type="textarea" rows="4"
                placeholder="输入json格式" style="width: 100%"
                @on-blur="switch_change('jump_title', receiver_info.jump_title)" />

            </div>
            <div class="setting_div3">
              <div>
                功能按钮配置
              </div>
              <Input v-model="receiver_info.jump_item" maxlength="250" show-word-limit type="textarea" rows="4"
                placeholder="输入json格式" style="width: 100%"
                @on-blur="switch_change('jump_item', receiver_info.jump_item)" />
            </div>
            <div class="setting_div3">
              <div class="chaosong_title2">
                <div class="chaosong_title">
                  抄送人
                </div>
                <Button @click="add_chaosong_show = true" style="font-size:13px" type="primary" size="small">添加</Button>
              </div>

              <div v-for="(item, i) in receiver_info.chaosong_user_list" :key="i" class="chaosong_user">
                <div>
                  <img :src="item.avatar" alt="" style="width:40px;height:40px;border-radius: 5px;">
                </div>
                <div class="chaosong_user_name">
                  {{ item.name }}
                </div>
                <div class="trash_chaosong" @click="del_chaosong(item, i)">
                  <Icon type="ios-trash" size='18' color="red" />删除
                </div>
              </div>
              <div v-if="receiver_info.chaosong_user_list.length == 0">
                无
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal width="420" v-model="add_chaosong_show" title="添加抄送人" :footer-hide="true">
      <div>
        <Input v-model="add_chaosong_value" placeholder="请输入用户id,多个用逗号间隔" style="width: 380px" />
      </div>
      <div @click="click_submit_add_chaosong" class="add_btn_div">
        <Button type="primary">确认更新</Button>
      </div>
    </Modal>


    <Modal width="420" v-model="update_template_show" title="更新消息" :footer-hide="true">
      <div>
        <span>模板标题：</span>
        <Input v-model="update_template_item.title" placeholder="模板标题" style="width: 380px" />
      </div>

      <div style="margin-top:5px;">
        <span>组名：</span>
        <Input v-model="update_template_item.group_id" placeholder="请输入组id" style="width: 380px" />
      </div>
      <div @click="update_template_confirm" class="add_btn_div">
        <Button type="primary">确认更新</Button>
      </div>
    </Modal>

    <Modal width="420" v-model="add_show" title="添加模板" :footer-hide="true">
      <div>
        <Input v-model="add_template_item.title" placeholder="模板标题" style="width: 380px" />
      </div>
      <div class="field_box">
        <div v-for="(item, i) in add_template_item.field_list" :key="i">
          文本类型：
          <Input v-model="item.name" placeholder="名称" style="width: 300px" />
        </div>
      </div>
      <div @click="add_field" class="add_field_btn">添加标题</div>
      <div @click="add_template_confirm" class="add_btn_div">
        <Button type="primary">确认添加</Button>
      </div>
    </Modal>

    <Modal width="420" v-model="add_field_show" title="添加字段" :footer-hide="true">
      <div>
        <Input v-model="add_field_name" placeholder="字段名称" style="width: 380px" />
      </div>

      <div @click="add_template_field" class="add_btn_div21">
        <Button type="primary">确认添加</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      template_data: [],
      loading: false,
      template_select: 0,
      current_field_data: [],

      add_template_item: {
        title: "",
        field_list: [],
      },
      add_show: false,

      add_field_show: false,
      current_template: {},
      add_field_name: "",

      update_template_show: false,
      update_template_item: {},
      receiver_info: { chaosong_user_list: [] },
      add_chaosong_show: false,
      add_chaosong_value: '',
      use_count: 0,
      right_loading: false
    };
  },

  mounted() {
    this.window_change();
    this.get_template_list();
  },

  methods: {

    click_submit_add_chaosong() {
      this.add_chaosong_show = false
      this.switch_change('chaosong_user_add', this.add_chaosong_value)
    },

    update_template_confirm() {
      var that = this;
      var obj = {
        title: this.update_template_item.title,
        template_id: this.update_template_item.template_id,
        group_id: this.update_template_item.group_id
      };
      console.log('更新')
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/msg_manage/template/template_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);

            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_template_list();
            that.update_template_show = false
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },
    update_template(e) {
      this.update_template_show = true
      this.update_template_item = e
    },

    copy_id(item) {
      this.$Copy({
        text: item.template_id,
      });
    },

    click_add_template() {
      this.add_show = true;
    },

    add_field() {
      var _dict = {
        name: "",
        type: "text",
      };
      this.add_template_item.field_list.push(_dict);
    },

    click_template(item, i) {
      console.log(item);
      this.template_select = i;
      this.current_field_data = item.field_data;
      this.current_template = item;
      this.get_receiver_info()

    },

    switch_change(key, e) {
      var that = this;
      console.log(key, e)
      var obj = {
        template_id: this.current_template.template_id,
        key: key,
        value: e
      };
      console.log(obj);
      http(
        "post",
        process.env.VUE_APP_HOST + "/msg_manage/template/template_receiver_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_receiver_info()
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {

          console.log(res, "请求出错");
        });
    },

    // 获取接收人信息
    get_receiver_info() {
      var that = this;
      var obj = {
        template_id: this.current_template.template_id
      };
      that.right_loading = true
      console.log(obj);
      http(
        "post",
        process.env.VUE_APP_HOST + "/msg_manage/template/template_receiver",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.receiver_info = res.data.receiver_info
            that.use_count = res.data.use_count

          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.right_loading = false
        })
        .catch((res) => {
          that.right_loading = false
          console.log(res, "请求出错");
        });
    },

    // 获取
    get_template_list() {
      var that = this;
      var obj = {};
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/msg_manage/template/template_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.template_data = res.data.template_list;
            if (res.data.template_list.length > 0) {
              that.current_field_data =
                res.data.template_list[that.template_select]["field_data"];
              that.current_template = res.data.template_list[that.template_select]
              that.get_receiver_info()
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    add_template_confirm() {
      var that = this;
      var obj = {
        title: this.add_template_item.title,
        field_list: this.add_template_item.field_list,
      };
      this.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/msg_manage/template/template_add",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);

            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_template_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    click_add_field() {
      this.add_field_show = true;
    },

    add_template_field() {
      var that = this;
      var obj = {
        template_id: this.current_template.template_id,
        name: this.add_field_name,
      };
      this.loading = true;
      http("post", process.env.VUE_APP_HOST + "/msg_manage/template/add_field", obj, true)
        .then((res) => {
          if (res.code == 0) {
            console.log(res);

            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_field_show = false;
            that.get_template_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          that.loading = false;

          console.log(res, "请求出错");
        });
    },

    del_chaosong(item, i) {
      var that = this
      var user_list = this.receiver_info.chaosong_user_list
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认要删除这个抄送人吗？</p>',
        onOk: () => {

          that.switch_change('chaosong_user_del', item.user_id)


        },
        onCancel: () => {

        }
      });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.avatar_img {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}

.sender_name {
  display: flex;
  justify-content: space-between;
  margin-left: 5px;
}

.sender_box {
  display: flex;
  align-items: center;
  padding: 10px 5px;
  margin: 0 0 10px 0;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

.trash_chaosong {
  position: absolute;
  right: 20px;
  cursor: pointer;
}

.chaosong_title2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.setting_font {
  font-weight: 600;
  color: #333;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.setting_div2 {
  border-left: 1px solid #ccc;
  padding: 10px;
  width: 320px;
  position: relative;

}

.template_title {
  display: flex;

}

.template_number {
  width: 20px;
  margin-right: 5px;
  font-size: 13px;
  height: 20px;
  border-radius: 3px;
  background-color: #a7b7ca;
  text-align: center;
  color: #fff;
}

.chaosong_title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px
}

.chaosong_user_name {
  margin-left: 10px
}

.chaosong_user {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #efefef;
  padding-bottom: 5px;
}

.setting_div3 {
  padding: 10px;
  font-size: 13px;
  color: #888;
}


.setting_div {
  color: #333;
  width: 300px;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.template_id {
  font-size: 13px;
  color: #ccc;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.template_right {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
}

.add_btn_div {
  display: flex;
  justify-content: end;
  margin: 20px 10px 0 0
}

.add_btn_div21 {
  display: flex;
  margin-top: 20px;
  justify-content: end;
}

.field_box {
  margin-top: 20px;
}

.add_field_btn {
  background-color: #0466dd;
  font-size: 12px;
  padding: 5px;
  width: 80px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  margin: 20px 0;
}

.field_type {
  margin-left: 20px;
}

.template_div {
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  font-size: 13px;
  margin-bottom: 10px;
  background-color: #e3f1fa;
}

.right_box {
  margin: 0 0 0 10px;
  width: 100%;
  min-width: 600px;
  display: flex;
  background-color: #fff;
}

.template_card {
  background-color: #fff;
  padding: 10px 10px;
}

.create_time {
  text-align: right;
  font-size: 10px;
  margin-top: 10px;
}

.left_list_card {
  background: hsl(213, 53%, 55%);
  color: #fff;
  cursor: pointer;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

.left_list_card2 {
  background: #fff;
  color: #333;
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid #ececec;
  display: flex;
  justify-content: space-between;
}

.left_list_card3 {
  background: #fff;
  color: #333;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid #ececec;
}

.left_list {
  width: 400px;
  background: #fff;
  height: calc(100vh - 20px);
  overflow: auto;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
  display: flex;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 220px);
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
